import { useInView, IntersectionOptions, InViewHookResponse } from 'react-intersection-observer';
import { useEffect, useState } from 'react';

/**
 * Wrapper hook to useInView so that it only triggers once. Useful for lazy-loaded content that
 * doesn't need to change once it's out of view.
 */
export function useInViewOnce(options: IntersectionOptions = {}): InViewHookResponse {
	const inViewHookResponse = useInView(options);
	const [viewed, setViewed] = useState(false);

	useEffect(() => {
		if (inViewHookResponse.inView) {
			setViewed(true);
		}
	}, [inViewHookResponse.inView]);

	const newResponse: InViewHookResponse = {
		...inViewHookResponse,
		inView: viewed,
		[0]: inViewHookResponse[0],
		[1]: viewed,
		[2]: inViewHookResponse[2],
	};

	function* makeIterator() {
		yield newResponse[0];
		yield newResponse[1];
		yield newResponse[2];
	}

	newResponse[Symbol.iterator] = makeIterator;

	return newResponse;
}
